import { useField } from 'formik'
import { type FC, useEffect, useState } from 'react'
import FormSelect from '../FormSelect/FormSelect'
import { type Values } from '../../SignUpForm.interface'
import styles from '../FormSelect/FormSelect.module.scss'

const options = [
  {
    id: '1',
    value: 'yes',
    label: 'Yes'
  },
  {
    id: '2',
    value: 'no',
    label: 'No'
  }
]
interface IndependantCheckProps {
  name: keyof Values;
  label: string;
  placeholder?: string;
  setMainError: (msg: string | boolean) => void;
}

export const IndependantCheck: FC<IndependantCheckProps> = ({
  name,
  label,
  placeholder,
  setMainError
}) => {
  const [hasError, setHasError] = useState(false)
  const [field] = useField(name)
  const [error, setError] = useState('')
  useEffect(() => {
    if (field.value === 'no') {
      setMainError(true)
      setError?.('We only promote independent businesses. As your business is not independent, we cannot accept your application.')
      setHasError(true)
    } else {
      setError?.('')
      setHasError(false)
    }
  }, [field.value, setError, setMainError])

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <FormSelect
        name={name}
        label={label}
        options={options}
        placeholder={placeholder}
        errorOverride={hasError}
      />
      <div className={styles['form-input__error-message']}>
        {error}
      </div>
    </div>
  )
}
